import { extend } from 'sk-ui/lib/utils/util.js'

import featureDetail from './metaData/featureDetail'
import featureForm from './metaData/featureForm'
import relateTestCase from './metaData/relateTestCase'
import relateTestCaseTable from './metaData/relateTestCaseTable'

import { getSpecFeatureInfo } from '@/api/businessResearch'
import copyFeature from '@/components/CopyFeature'
export default {
  featureCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: featureForm,
      props
    })
  },
  featureEdit({ commit }, params) {
    const props = {
      title: '编辑功能',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, featureForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  FeatureCopy({ commit }, params) {
    getSpecFeatureInfo({ id: params.rowId }).then(response => {
      var title = '复制功能'
      var dialog = params.viewController.$dialog({
        template: h => {
          const feature = response?.data?.content
          return (
            <sky-copy-feature
              feature={feature}
              onCb={function() {
                dialog.remove()
                params.viewController.fetch()
              }}
            />
          )
        },
        components: {
          copyFeature
        },
        props: {
          title: title,
          width: '65%',
          showDefaultFooter: false,
          closeOnPressEscape: false
        }
      })
    })
  },
  featureRelateTestCase({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        featureId: params.rowIds[0],
        productVersion: params.row.productVersion
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: relateTestCase,
      props
    })
  },
  featureRelationTestCase({ commit }, props) {
    if (props?.rootView?.views?.extraParams?.productVersion) {
      if (!props.params) {
        props.params = {}
      }
      props.params = {
        productVersion: props?.rootView?.views?.extraParams?.productVersion
      }
    }

    import('../caseBusiMng/metaData/caseBusi').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  showFeatureRelationTestCase({ commit }, row) {
    const props = {
      params: {
        featureId: row.featureId
      }
    }

    const relateTestCaseTableCopy = extend(true, {}, relateTestCaseTable)
    this.dispatch('OpenDraweDetailRelation', {
      metaData: relateTestCaseTableCopy,
      props,
      drawerProps: {
        title: '功能【' + row.featureName + '】关联用例详情',
        class: 'wsp-case-relation-drawer-65'
      }
    })
  },
  featureDetail({ commit }, row) {
    const props = {
      params: {
        id: row.id
      },
      'view.tabs[1].viewMetaData.params': {
        featureId: row.id
      }
    }
    const featureDetailCopy = extend(true, {}, featureDetail)
    this.dispatch('OpenDetailDialog', {
      metaData: featureDetailCopy,
      props
    })
  }
}
